<template>
  <div id="navtop">
    <v-app-bar app flat color="white">
      <v-app-bar-nav-icon
        color="black"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <span class="brand-name">ALPHYIAGO</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="hide-home mr-10" icon router to="/about" color="#333">
        <span class="font-weight-bold">About</span>
      </v-btn>
      <v-btn class="hide-home mr-10" icon router to="/contact" color="#333">
        <span class="font-weight-bold">Contact</span>
      </v-btn>
      <v-btn class="hide-home" icon router to="/gallery" color="#333">
        <span class="font-weight-bold">Gallery</span>
      </v-btn>
      <div class="badge-inside hide-home">
        <v-divider class="ml-5 mr-4 hide-home" vertical></v-divider>
      </div>
      <v-btn class="hide-home" icon router to="/" color="#ffffff">
        <v-icon right color="#000" size="30">mdi-home-circle-outline</v-icon>
      </v-btn>
      <v-btn class="hide-home" icon router to="/about" color="#ffffff">
        <v-icon right color="#000" size="30">mdi-account-circle-outline</v-icon>
      </v-btn>
      <div>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="black"
              right
              size="25"
              v-bind="attrs"
              class="ml-2"
              v-on="on"
              >mdi-dots-vertical</v-icon
            >
          </template>
          <v-card class="mx-auto" width="200">
            <v-list>
              <v-list-item @click="share">
                <v-list-item-icon>
                  <v-icon>mdi-share-variant-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Share</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-for="link in links"
                :key="link.name"
                router
                :to="link.router"
              >
                <v-list-item-icon>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ link.name }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="deferredPrompt" @click="install">
                <v-list-item-icon>
                  <v-icon>mdi-arrow-down-bold-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Install App</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="/img/icon.png" alt="logo"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title><strong>ALPHYIAGO</strong></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list dense>
        <v-list-item
          v-for="seaview in seaview"
          :key="seaview.link"
          router
          :to="seaview.router"
        >
          <v-list-item-icon>
            <v-icon>{{ seaview.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ seaview.link }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list dense>
        <v-subheader>Information</v-subheader>
        <v-list-item
          v-for="info in information"
          :key="info.link"
          router
          :to="info.router"
        >
          <v-list-item-icon>
            <v-icon>{{ info.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ info.link }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense class="mb-8">
        <v-subheader>More</v-subheader>
        <v-list-item
          v-for="inf in info"
          :key="inf.link"
          router
          :to="inf.router"
        >
          <v-list-item-icon>
            <v-icon>{{ inf.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ inf.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer: null,
      deferredPrompt: null,
      user: null,
      links: [{ name: 'Help', icon: 'mdi-help', router: '/help' }],
      seaview: [{ icon: 'mdi-home', link: 'HOME', router: '/' }],
      information: [
        {
          icon: 'mdi-account-details',
          link: 'ABOUT US',
          router: '/about',
        },
        {
          icon: 'mdi-card-account-phone',
          link: 'CONTACT',
          router: '/contact',
        },
        { icon: 'mdi-folder-image', link: 'GALLERY', router: '/gallery' },
        {
          icon: 'mdi-facebook',
          link: 'FACEBOOK',
          router: '/facebook',
        },
      ],
      info: [
        {
          name: 'ADVERTS',
          icon: 'mdi-bullhorn-outline',
          router: '/advert',
        },
        {
          name: 'SUPPORT',
          icon: 'mdi-account-multiple',
          router: '/support',
        },
        { name: 'HELP', icon: 'mdi-help', router: '/help' },
      ],
    }
  },
  created() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPrompt = e
    })
  },
  methods: {
    async share() {
      if (navigator.canShare) {
        navigator.share({
          text: 'Velabahleke High School',
          url: 'https://velabahlekehighsite.web.app/',
        })
      }
    },
    async install() {
      this.deferredPrompt.prompt()
    },
  },
}
</script>